export enum ExportableListType {
  BOOKINGS = 'bookings',
  TRIPS = 'trips',
  USERS = 'users',
  DRIVERS = 'drivers',
}

export enum ListExportScope {
  ALL = 'all',
  VISIBLE = 'visible',
}

export enum ListExportStep {
  IDLE = 'idle',
  CHOOSING = 'choosing',
  EXPORTING = 'exporting',
}
